export default __webpack_public_path__ + "static/media/termination-request.1d35dc34.png";